import { useSelector } from "react-redux";
import MessageContainer from "./MessageContainer";
import MessageFooter from "./MessageFooter";
import TemplateComponent from "./TemplateComponent";
import { parseTemplateComponent, substituteVariables } from "../templateMessageUtils";

export default function TemplateMessage({ message }) {
  const { content, direction, status, createdAt } = message;
  const isOutbound = direction === "OUTBOUND";
  const template = content.template;
  
  const templates = useSelector((state) => state.whatsapp?.templates || []);

  if (!template) {
    return null;
  }

  const components = template.components || [];

  const originalTemplate = templates.find(
    (t) => t.name === template.name && (t.language === template.language?.code || t.language?.code === template.language?.code)
  );

  const renderTemplateContent = () => {
    if (!originalTemplate) {
      return (
        <div className="space-y-2">
          {components.map((component, idx) => (
            <TemplateComponent key={idx} component={component} />
          ))}
        </div>
      );
    }

    const headerDef = parseTemplateComponent(originalTemplate?.components?.HEADER);
    const bodyDef = parseTemplateComponent(originalTemplate?.components?.BODY);
    const footerDef = parseTemplateComponent(originalTemplate?.components?.FOOTER);
    const buttonsDef = parseTemplateComponent(originalTemplate?.components?.BUTTONS);

    const getParamValues = (compType) => {
      const comp = components.find((c) => String(c.type).toLowerCase() === compType);
      if (!comp || !comp.parameters) return {};
      return comp.parameters.reduce((acc, p) => {
        if (p.type === "text" && p.parameter_name) {
          acc[p.parameter_name] = p.text;
        }
        return acc;
      }, {});
    };

    const headerValues = getParamValues("header");
    const bodyValues = getParamValues("body");

    const headerText = substituteVariables(headerDef?.text || originalTemplate?.headerText || "", headerValues, true);
    const bodyText = substituteVariables(bodyDef?.text || originalTemplate?.body || "", bodyValues, true);
    const buttonsList = Array.isArray(buttonsDef) ? buttonsDef : buttonsDef?.buttons || [];

    const headerComponent = components.find((c) => String(c.type).toLowerCase() === "header");

    return (
      <div className="space-y-2">
        {headerComponent && <TemplateComponent component={headerComponent} hideText={true} />}
        {headerText && <div className="text-sm font-bold break-words">{headerText}</div>}
        {bodyText && <div className="text-sm whitespace-pre-wrap break-words">{bodyText}</div>}
        {footerDef?.text && <div className="text-xs text-gray-500 mt-1 break-words">{footerDef.text}</div>}
        {buttonsList.length > 0 && (
          <div className="space-y-1 mt-2">
            {buttonsList.map((btn, idx) => (
              <button key={idx} className="w-full text-blue-500 dark:text-blue-400 text-sm py-1 border-t border-gray-100 dark:border-slate-800" disabled>
                {btn.text}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <MessageContainer isOutbound={isOutbound} className="p-3 max-w-sm">
      {renderTemplateContent()}
      <MessageFooter status={status} timestamp={createdAt} isOutbound={isOutbound} />
    </MessageContainer>
  );
}
